// test963
(963 && 0);
